import axios, { AxiosError } from 'axios'
import { BASEURL } from './const'
import { parseAxiosError } from '../common/constant'

const AxiosInstance = axios.create({
  baseURL: `${BASEURL}/doc`
})

export const codeToDocument = async (formData: any) => {
  try {
    const response = await AxiosInstance.post('/codeToDocument', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response?.data;
  } catch (error: any) {
    return parseAxiosError(error as AxiosError);
  }
}

export const aiCodeReview = async (formData: any) => {
  try {
    const response = await AxiosInstance.post('/aiCodeReview', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response?.data;
  } catch (error: any) {
    return parseAxiosError(error as AxiosError);
  }
}

export const codeReviewReport = async (body: any) => {
  try {
    const response = await AxiosInstance.post('/codeReviewReport', body)
    return response?.data;
  } catch (error: any) {
    return parseAxiosError(error as AxiosError);
  }
}

export const editDocumentation = async (body: any) => {
  try {
    const response = await AxiosInstance.post('/editDocumentation', body)
    return response?.data;
  } catch (error: any) {
    return parseAxiosError(error as AxiosError);
  }
}